var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"project--detail-similar"},[_c('h2',{staticClass:"title--text"},[_vm._v(" "+_vm._s(_vm.$t('general.unitTypes'))+" ")]),(_vm.unitTypes && _vm.unitTypes.length > 0)?_c('div',[_c('slick-unit-types',{attrs:{"contents":_vm.unitTypes,"slidesPerRow":3}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }